import { FORM_TYPES } from 'utils/constants';

export const serviceCenterOnboardingMockFormConfig = [
    {
        form_type: FORM_TYPES.SERVICE_CENTER_DETAILS,
        section_title: 'Service Center Details',
        should_capture_details: false,
        details_update_required: false,
        captured_data: {
            service_center_name: '',
            service_center_phone: '',
            service_center_email: '',
            service_center_address: '',
            service_center_pincode: '',
        },
        ui_config: [
            {
                id: 'service-center-name',
                type: 'text',
                label: 'Name',
                title: 'Service center name',
                component: 'input',
                required: true,
                props: {
                    key_name: 'service_center_name',
                    editable: false,
                    section: 'service_center_details',
                },
            },
            {
                id: 'service-center-phone',
                type: 'tel',
                label: 'Phone',
                title: 'Service center phone',
                component: 'input',
                required: true,
                props: {
                    key_name: 'service_center_phone',
                    editable: false,
                    section: 'service_center_details',
                },
            },
            {
                id: 'service-center-email',
                type: 'email',
                label: 'Email',
                title: 'Service center email',
                component: 'input',
                required: false,
                props: {
                    key_name: 'service_center_email',
                    editable: false,
                    section: 'service_center_details',
                },
            },
            {
                id: 'service-center-address',
                type: 'text',
                label: 'Address',
                title: 'Service center address',
                component: 'input',
                required: true,
                props: {
                    key_name: 'service_center_address',
                    editable: false,
                    section: 'service_center_details',
                },
            },
            {
                id: 'service-center-pincode',
                type: 'text',
                label: 'Pincode',
                title: 'Service center pincode',
                component: 'input',
                required: true,
                props: {
                    key_name: 'service_center_pincode',
                    editable: false,
                    section: 'service_center_details',
                },
            },
        ],
    },
    {
        form_type: FORM_TYPES.SERVICE_CENTER_PROFESSIONAL_DETAILS,
        section_title: 'Professional Details',
        should_capture_details: false,
        details_update_required: false,
        captured_data: {
            gst_number: '',
            pan_number: '',
            pan_image: '',
        },
        ui_config: [
            {
                id: 'gst-number',
                type: 'text',
                label: 'GST number',
                title: 'GST number',
                component: 'input',
                required: true,
                props: {
                    key_name: 'gst_number',
                    editable: false,
                    section: 'professional_details',
                },
            },
            {
                id: 'pan-number',
                type: 'text',
                label: 'PAN number',
                title: 'PAN number',
                component: 'input',
                required: true,
                props: {
                    key_name: 'pan_number',
                    editable: false,
                    section: 'professional_details',
                },
            },
            {
                id: 'pan-image',
                type: 'image',
                label: 'PAN image',
                title: 'PAN image',
                component: 'image_preview',
                required: false,
                props: {
                    key_name: 'pan_image',
                    editable: false,
                    section: 'professional_details',
                },
            },
        ],
    },
    {
        form_type: FORM_TYPES.SERVICE_CENTER_BANK_DETAILS,
        section_title: 'Bank Account Details',
        should_capture_details: false,
        details_update_required: false,
        captured_data: {
            bank_name: '',
            ifsc_code: '',
            bank_account_name: '',
            account_number: '',
            cancelled_cheque: '',
        },
        ui_config: [
            {
                id: 'bank-name',
                type: 'text',
                label: 'Bank name',
                title: 'Bank name',
                component: 'input',
                required: true,
                props: {
                    key_name: 'bank_name',
                    editable: false,
                    section: 'bank_details',
                },
            },
            {
                id: 'ifsc-code',
                type: 'text',
                label: 'IFSC code',
                title: 'IFSC code',
                component: 'input',
                required: true,
                props: {
                    key_name: 'ifsc_code',
                    editable: false,
                    section: 'bank_details',
                },
            },
            {
                id: 'bank-account-name',
                type: 'text',
                label: 'Bank account name',
                title: 'Bank account name',
                component: 'input',
                required: true,
                props: {
                    key_name: 'bank_account_name',
                    editable: false,
                    section: 'bank_details',
                },
            },
            {
                id: 'account-number',
                type: 'text',
                label: 'Account number',
                title: 'Account number',
                component: 'input',
                required: true,
                props: {
                    key_name: 'account_number',
                    editable: false,
                    section: 'bank_details',
                },
            },
            {
                id: 'cancelled-cheque',
                type: 'image',
                label: 'Cancelled cheque',
                title: 'Cancelled cheque',
                component: 'image_preview',
                required: false,
                props: {
                    key_name: 'cancelled_cheque',
                    editable: false,
                    section: 'bank_details',
                },
            },
        ],
    },
    {
        form_type: FORM_TYPES.SERVICE_CENTER_POC_DETAILS,
        section_title: 'POC Details',
        should_capture_details: true,
        details_update_required: false,
        captured_data: {
            communication_name: '',
            communication_phone: '',
            communication_email: '',
        },
        ui_config: [
            {
                id: 'communication-name',
                type: 'text',
                label: 'Communication name',
                title: 'Enter communication name',
                component: 'input',
                required: true,
                props: {
                    key_name: 'communication_name',
                    editable: true,
                    section: 'poc_details',
                },
            },
            {
                id: 'communication-phone',
                type: 'tel',
                label: 'Communication phone',
                title: 'Enter communication phone',
                component: 'input',
                required: true,
                props: {
                    key_name: 'communication_phone',
                    editable: true,
                    section: 'poc_details',
                },
            },
            {
                id: 'communication-email',
                type: 'email',
                label: 'Communication email (optional)',
                title: 'Enter communication email',
                component: 'input',
                required: false,
                props: {
                    key_name: 'communication_email',
                    editable: true,
                    section: 'poc_details',
                },
            },
        ],
    },
    {
        form_type: FORM_TYPES.SERVICE_CENTER_TNC,
        section_title: 'I agree to terms and conditions',
        should_capture_details: true,
        details_update_required: false,
        captured_data: {
            tnc_reveal: false,
            tnc_accepted: false,
            tnc_url: '',
        },
        ui_config: [
            {
                id: 'tnc-reveal',
                type: 'checkbox',
                label: 'I agree to terms and conditions',
                title: 'Open terms and conditions',
                component: 'tnc_reveal_checkbox',
                required: true,
                props: {
                    key_name: 'tnc_reveal',
                    editable: true,
                    section: 'tnc',
                },
            },
            {
                id: 'tnc-preview',
                type: 'url',
                label: 'Terms and conditions preview',
                title: 'Terms and conditions',
                component: 'tnc_preview',
                required: true,
                props: {
                    key_name: 'tnc_url',
                    editable: false,
                    section: 'tnc',
                },
            },
            {
                id: 'tnc-accepted',
                type: 'checkbox',
                label: 'I have read and accept the terms and conditions',
                title: 'Accept terms and conditions',
                component: 'tnc_accept_checkbox',
                required: true,
                props: {
                    key_name: 'tnc_accepted',
                    editable: true,
                    section: 'tnc',
                },
            },
        ],
    },
];
